import { FC } from 'react'

import { JsonLoader } from 'components/atoms/JsonLoader'

import { CardListPager } from './CardListPager'
import {
  EmailAlertReportCard,
  NotificationRecipientCard,
} from './EmailAlertReportCard'

export interface EmailAlertsCardListProps {
  cards: NotificationRecipientCard[]
  isLoading: boolean
  partnerFilterIsAll: boolean
  canEdit: boolean
  onManageClick: (card: NotificationRecipientCard) => void
  onEditClick: (card: NotificationRecipientCard) => void
  onDeleteClick: (card: NotificationRecipientCard) => void
  pageNumber: number
  take: number
  totalCount: number
  onPageChange: (page: number) => void
  onTakeChange: (take: number) => void
}

export const EmailAlertsCardList: FC<EmailAlertsCardListProps> = ({
  cards,
  isLoading,
  partnerFilterIsAll,
  canEdit,
  onManageClick,
  onEditClick,
  onDeleteClick,
  pageNumber,
  take,
  totalCount,
  onPageChange,
  onTakeChange,
}: EmailAlertsCardListProps) => {
  return (
    <div className='mt-4'>
      <div className='relative flex flex-col gap-3.5 min-h-[120px]'>
        {isLoading && (
          <div className='flex w-full h-full items-center justify-center bg-N-800 absolute z-[1] bg-opacity-10 cursor-not-allowed rounded-md'>
            <JsonLoader size='xxs' />
          </div>
        )}

        {!isLoading && cards.length === 0 && (
          <div className='border-[1.5px] border-dashed border-N-200 rounded-md px-[18px] py-6 text-center text-[13px] text-N-500'>
            No reports match the current filters.
          </div>
        )}

        {cards.map((card) => (
          <EmailAlertReportCard
            key={`${card.partnerId}|${card.serviceName}`}
            card={card}
            showPartnerLabel={partnerFilterIsAll}
            canEdit={canEdit}
            onManageClick={onManageClick}
            onEditClick={onEditClick}
            onDeleteClick={onDeleteClick}
          />
        ))}
      </div>

      {totalCount > 0 && (
        <CardListPager
          pageNumber={pageNumber}
          take={take}
          totalCount={totalCount}
          onPageChange={onPageChange}
          onTakeChange={onTakeChange}
        />
      )}
    </div>
  )
}

export default EmailAlertsCardList
